import React, { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useForm, FormProvider } from 'react-hook-form';
import { Typography } from '@mui/material';
import AddressLocationFields from '#component/addressbook/contact-form/address-location-fields';
import RHFTextField from '#component/form/rhf/rhf-text-field';
import RHFAutocomplete from '#component/form/rhf/rhf-autocomplete';
import { reduxFormResolver } from '#helper/rhf-resolver';
import validate from './validate';
import {
  ContactFormContainer,
  ContactFormPaper,
  ButtonContainer,
  ContactFormButton
} from './styles';

const FORM_NAME = 'AddressbookContactForm';

/**
 * Renders addressbook contact react-hook-form fields.
 * @returns {React.FC}
 */

const Form = props => {
  const { onSubmit, initialValues, pageDescription, history, measurementSystem } = props;
  const { addressbooks, status } = useSelector(s => s.addressbooks, shallowEqual);

  const methods = useForm({
    resolver: reduxFormResolver(validate),
    context: { measurementSystem },
    defaultValues: initialValues || {}
  });

  const { handleSubmit, formState: { isDirty, isSubmitting }, reset } = methods;

  useEffect(() => {
    if (initialValues) {
      reset(initialValues);
    }
  }, [initialValues, reset]);

  const handleCancelClick = () => {
    history.push('/addressbook');
  };

  return (
    <FormProvider {...methods}>
      <ContactFormContainer autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <Typography variant="h4" gutterBottom>
          {pageDescription}
        </Typography>
        <ContactFormPaper elevation={0}>
          <RHFTextField
            name="firstName"
            label="First name"
            variant="outlined"
            fullWidth
          />
          <RHFTextField
            name="lastName"
            label="Last name"
            variant="outlined"
            fullWidth
          />
          <RHFTextField
            name="email"
            label="Email"
            variant="outlined"
            fullWidth
          />
          <RHFTextField
            name="companyName"
            label="Company name"
            variant="outlined"
            fullWidth
          />
          <AddressLocationFields id={FORM_NAME} />
          <RHFAutocomplete
            name="addressbook"
            loading={status === 'loading'}
            options={addressbooks}
            getOptionLabel={option => option.label || ''}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            fullWidth
            inputProps={{ label: 'Address book', variant: 'outlined' }}
          />
        </ContactFormPaper>
        <ButtonContainer>
          <ContactFormButton
            variant="outlined"
            onClick={handleCancelClick}
          >
            Cancel
          </ContactFormButton>
          <ContactFormButton
            type="submit"
            variant="contained"
            color="secondary"
            disabled={!isDirty || isSubmitting}
          >
            Save
          </ContactFormButton>
        </ButtonContainer>
      </ContactFormContainer>
    </FormProvider>
  );
};

export default Form;
